var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLetterM(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 80V0h22.86v11.43h11.43v11.43h11.42V11.43h11.43V0H80v80H57.14V34.29H45.71v22.85H34.29V34.29H22.86V80z",
    fill: "#e8ffa2"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4MCIgaGVpZ2h0PSI4MCIgdmlld0JveD0iMCAwIDgwIDgwIj4KICA8cGF0aCBkPSJNMCw4MFYwSDIyLjg2VjExLjQzSDM0LjI5VjIyLjg2SDQ1LjcxVjExLjQzSDU3LjE0VjBIODBWODBINTcuMTRWMzQuMjlINDUuNzFWNTcuMTRIMzQuMjlWMzQuMjlIMjIuODZWODBaIiBmaWxsPSIjZThmZmEyIi8+Cjwvc3ZnPgo=";
export { SvgLetterM as ReactComponent };